import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const GeneralRun: string = import.meta.env.VITE_TEST_FRESHERS_GENERAL_RUN_URL;

interface QuizRunPayload {
  userCode: string;
  language: string;
}

export interface WorkSpaceRunCodeResponse {
  output?: string;
  compilationError?: string;
}

export const GeneralCodeRun = createApi({
  reducerPath: "RunCodeApi",
  baseQuery: fetchBaseQuery({ baseUrl: GeneralRun }),
  endpoints: (builder) => ({
    workspaceRunCode: builder.mutation<
      WorkSpaceRunCodeResponse,
      QuizRunPayload
    >({
      query: (payload) => ({
        url: `api/submissions/compile`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});
export const { useWorkspaceRunCodeMutation } = GeneralCodeRun;
